module.exports = __webpack_public_path__ + "static/media/fruit-mango-2.7366a0e0.png";